import { accessMeta } from '@md/permissions'

const REDIRECTS = {
  parent: 'profile:notification:list',
  company: 'profile:notification:list',
  child: 'profile:notification:list',
  employee: 'profile:notification:list',
  teacher: 'profile:dashboard:list-teacher',
  manager: 'profile:orders:list',
}

const { userType } = window

const initialRoute = { name: REDIRECTS[userType] }

export const permissionChecker = perms => perms.includes(userType)

export const accessPermission = (permissions, options) => accessMeta(
  permissionChecker(permissions), initialRoute, options
)
